import "./App.css";
import "./index.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Header/header.jsx";
import Home from "./Pages/Home/home.js";
import { GlobalCapabilityCenter } from "./Pages/Services/global-capability-center.js";
import CenterOfExcellence from "./Pages/Services/center-of-excellence.js";
import ExecutiveSearch from "./Pages/Services/executive-search.js";
import ContactUs from "./Contact Us/contact-us.js";
import AllBlogs from "./Pages/Insights/allblogs.js";
import GPractaBlogDetails from "./Pages/Insights/gpracta-blog-details.js";
import NewsletterDetails from "./Pages/Insights/newsletter-details.js";
import PageNotFound from "./pagenotfound.js";
import BlogDetails from "./Pages/Insights/blog-details.js";
import FAQ from "./FAQ/faq.js";
import Policy from "./Policy/policy.js";
import GPractaNews from "./Pages/Insights/insights.js";
import GPractaBlogs from "./Pages/Insights/gpracta-blogs.js";
import OurStory from "./Pages/Our Story/our-story.jsx";
import ProductEngineering from "./Pages/Services/product-engineering.js";
import ReactGA from "react-ga4";

function App() {
  ReactGA.initialize("G-ETTDBDLTBG");

  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname + window.location.search,
    title: "GPracta Website",
  });

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header /> <Home />
            </>
          }
        />
        <Route
          path="/global-capability-centers"
          element={
            <>
              <Header /> <GlobalCapabilityCenter />
            </>
          }
        />
        <Route
          path="/center-of-excellence"
          element={
            <>
              <Header /> <CenterOfExcellence />
            </>
          }
        />
        <Route
          path="/executive-search"
          element={
            <>
              <Header /> <ExecutiveSearch />
            </>
          }
        />
        <Route
          path="/product-engineering"
          element={
            <>
              <Header /> <ProductEngineering />
            </>
          }
        />
        <Route
          path="/contact-us"
          element={
            <>
              <Header /> <ContactUs />
            </>
          }
        />
        <Route
          path="/blogs"
          element={
            <>
              <Header /> <AllBlogs />
            </>
          }
        />
        <Route
          path="/news"
          element={
            <>
              <Header /> <GPractaNews />
            </>
          }
        />
        <Route
          path="/gpracta-blogs"
          element={
            <>
              <Header /> <GPractaBlogs />
            </>
          }
        />
        <Route
          path="/gpracta-blog-details"
          element={
            <>
              <Header />
              <GPractaBlogDetails />
            </>
          }
        />
        <Route
          path="/newsletter-details"
          element={
            <>
              <Header />
              <NewsletterDetails />
            </>
          }
        />
        <Route
          path="/blog-details"
          element={
            <>
              <Header />
              <BlogDetails />
            </>
          }
        />
        <Route
          path="/faq"
          element={
            <>
              <Header />
              <FAQ />
            </>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <>
              <Header />
              <Policy />
            </>
          }
        />
        <Route
          path="/our-story"
          element={
            <>
              <Header />
              <OurStory />
            </>
          }
        />
        <Route
          path="/pagenotfound"
          element={
            <>
              <Header />
              <PageNotFound />
            </>
          }
        />
        <Route
          path="*"
          element={
            <>
              <PageNotFound />
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
